import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import { IPayrollTime } from "../models"

class PayrollStore extends EventEmitter {
    private payrollTime: IPayrollTime
    private exportEmployeeIds: string[]
    constructor() {
        super()
        this.setMaxListeners(0)
    }

    setPayrollTime(payrollTime: IPayrollTime) {
        this.payrollTime = payrollTime
        this.emit("payroll_time_change")
    }

    getPayrollTime() {
        return this.payrollTime
    }

    showExportPayrollTimeResult(exportEmployeeIds: string[]) {
        this.exportEmployeeIds = exportEmployeeIds
        this.emit("open_export_payroll_time_result_dialog")
    }

    getExportEmployeeIds() {
        return this.exportEmployeeIds
    }

    handleActions(action) {
        switch (action.type) {
            case "SET_PAYROLL_TIME":
                this.setPayrollTime(action.data)
                break
            case "SHOW_EXPORT_PAYROLL_TIME_RESULT":
                this.showExportPayrollTimeResult(action.data)
                break
        }
    }
}

const payrollStore = new PayrollStore()
dispatcher.register(payrollStore.handleActions.bind(payrollStore))
export default payrollStore
